// extracted by mini-css-extract-plugin
export default {"root":"Plaque_root__D+nCe","root__green":"Plaque_root__green__ths3M","root__title":"Plaque_root__title__gEivl","root__days":"Plaque_root__days__u00Qm"};